import { useCallback } from 'react';
import { useOutputMapperEditor } from '../OutputMapperEditorProvider.tsx';
import type { Action } from '../types.ts';

/**
 * Returns a unified update handler for action blocks.
 * If `onUpdate` is provided (nested action context), it routes through that.
 * Otherwise, it dispatches through the context's `updateAction`.
 */
export const useActionUpdate = <T extends Action>(
    mappingIndex: number,
    actionIndex: number,
    onUpdate?: (updates: Partial<T>) => void
) => {
    const { updateAction } = useOutputMapperEditor();

    return useCallback(
        (updates: Partial<T>) => {
            if (onUpdate) {
                onUpdate(updates);
            } else {
                updateAction(mappingIndex, actionIndex, updates);
            }
        },
        [mappingIndex, actionIndex, onUpdate, updateAction]
    );
};
